var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"green"}},[_c('v-card-text',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.selectedNanogenre))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }